import { AppFlow } from '@beecode/msh-node-app'
import { CommonLibInitiable } from 'src/app/init/common-lib-initiable'

export class WebApp extends AppFlow {
  constructor() {
    super(new CommonLibInitiable())
  }
}
